export const TAGGING_TEMPLATE_TYPE = 'TAGGING';
export const STANDARD_TEMPLATE_TYPE = 'STANDARD';

export const HEADER_ACTIONS = 'Actions';
export const HEADER_CHANNEL_NAME = 'channelName';
